import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { ISingleVehicleResponse } from "../models/Vehicle";
import { ISingleLeadRespose } from "../models/Lead";

export default function useVehicleSingle(vehicleId: string | undefined) {
  const { get, post, put } = useApiHelper();
  const queryClient = useQueryClient();

  const vehicle = useQuery({
    queryKey: ["vehicles", vehicleId],
    queryFn: () => get<ISingleVehicleResponse>(`/vehicle/${vehicleId}`),
    enabled: !!vehicleId,
    staleTime: 1000 * 60 * 10, // 10 minute
  });

  const lead = useQuery({
    queryKey: ["vehicle", vehicleId, "lead"],
    queryFn: () => get<ISingleLeadRespose>(`/vehicle/${vehicleId}/lead`),
    enabled: !!vehicleId,
    staleTime: 1000 * 60 * 10, // 10 minute
  });

  return {
    vehicle,
    lead
  };
}
